<template>
  <div class="config-page">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="系统配置" name="system">
        <tableComponents
          ref="tableComponents"
          :isHaveExport="false"
          :isShow="false"
          :isHavePagination="false"
          :isHaveAdd="true"
          @toAdd="toAdd"
        >
          <template v-slot:table>
            <div class="row" v-for="item in list" :key="item.id">
              <div class="left">
                <div class="title">{{ item.title }} [{{ item.iden }}]</div>
              </div>
              <div class="right">
                <template v-if="item.type == 1">
                  <el-input
                    v-model="item.value"
                    placeholder="请输入内容"
                    size="mini"
                    @blur="() => saveConfig(item)"
                  >
                  </el-input>
                </template>
                <template v-if="item.type == 2">
                  <el-radio-group
                    v-model="item.value"
                    @change="() => saveConfig(item)"
                  >
                    <el-radio
                      :label="radioItem"
                      v-for="(radioItem, i) in item.label"
                      :key="i"
                    >
                      {{ radioItem }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="item.type == 3">
                  <el-switch
                    v-model="item.value"
                    active-color="#13ce66"
                    inactive-value="0"
                    active-value="1"
                    @change="() => saveConfig(item)"
                  >
                  </el-switch>
                </template>
              </div>
            </div>
          </template>
        </tableComponents>
      </el-tab-pane>

      <el-tab-pane label="报表账户配置" name="report">
        <div class="report-account-card" v-loading="accountLoading">
          <div class="report-account-head">
            <div>
              <h3>报表账户配置</h3>
              <p>配置 Taku 报表账户连接信息，当前固定使用 global 账户。</p>
            </div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              :loading="accountLoading"
              @click="loadReportAccount"
            >
              刷新
            </el-button>
          </div>

          <el-form
            ref="reportAccountFormRef"
            class="mobile-stack-form"
            :model="reportAccountForm"
            :rules="reportAccountRules"
            label-width="130px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="账户编码">
                  <el-input v-model="reportAccountForm.account_code" disabled />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="状态" prop="status">
                  <el-radio-group v-model="reportAccountForm.status">
                    <el-radio label="active">active</el-radio>
                    <el-radio label="inactive">inactive</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="Publisher Key" prop="publisher_key">
                  <el-input
                    v-model.trim="reportAccountForm.publisher_key"
                    :type="showPublisherKey ? 'text' : 'password'"
                    placeholder="请输入 publisher_key"
                  >
                    <template slot="suffix">
                      <i
                        :class="showPublisherKey ? 'el-icon-view' : 'el-icon-hide'"
                        class="password-toggle"
                        @click="showPublisherKey = !showPublisherKey"
                      ></i>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="开通日期" prop="activation_date">
                  <el-date-picker
                    v-model="reportAccountForm.activation_date"
                    type="date"
                    placeholder="请选择开通日期"
                    value-format="timestamp"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="基础地址" prop="base_url">
                  <el-input
                    v-model.trim="reportAccountForm.base_url"
                    placeholder="请输入 base_url"
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="默认币种" prop="default_currency">
                  <el-input
                    v-model.trim="reportAccountForm.default_currency"
                    placeholder="请输入默认币种"
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="默认时区" prop="default_time_zone">
                  <el-input
                    v-model.trim="reportAccountForm.default_time_zone"
                    placeholder="请输入默认时区"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="report-account-actions">
            <el-button @click="resetReportAccountForm">重置</el-button>
            <el-button
              type="primary"
              :loading="accountSaving"
              @click="saveReportAccount"
            >
              保存配置
            </el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <Dialog
      ref="appConfigDialogRef"
      :formData="formData"
      dialogWidth="50%"
      @onSave="submitForm"
      :keySpan="6"
    >
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog.vue";
import { formatDateToYYYYMMDD } from "@/utils/report";

function createDefaultReportAccountForm() {
  return {
    publisher_key: "",
    activation_date: "",
    account_code: "global",
    base_url: "https://openapi.toponad.com",
    default_currency: "USD",
    default_time_zone: "UTC+8",
    status: "active",
  };
}

function normalizeActivationDate(value) {
  if (!value) {
    return "";
  }

  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string" && /^\d{8}$/.test(value)) {
    const year = Number(value.slice(0, 4));
    const month = Number(value.slice(4, 6)) - 1;
    const day = Number(value.slice(6, 8));
    return new Date(year, month, day).getTime();
  }

  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? "" : parsed;
}

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      activeTab: "system",
      list: [],
      accountLoading: false,
      accountSaving: false,
      accountLoaded: false,
      showPublisherKey: false,
      reportAccountForm: createDefaultReportAccountForm(),
      formData: [
        {
          type: "text",
          key: "title",
          placeholder: "请输入标题",
          label: "标题",
        },
        {
          type: "text",
          key: "value",
          placeholder: "请输入值",
          label: "值",
        },
        {
          type: "text",
          key: "label",
          placeholder: "label",
          label: "label",
        },
        {
          type: "select",
          key: "type",
          placeholder: "请选择类型",
          label: "类型",
          option: [
            {
              title: "文本",
              id: "1",
            },
            {
              title: "单选框",
              id: "2",
            },
            {
              title: "开关",
              id: "3",
            },
          ],
        },
        {
          type: "text",
          key: "iden",
          placeholder: "请输入 iden",
          label: "iden",
        },
      ],
      reportAccountRules: {
        publisher_key: [
          { required: true, message: "请输入 publisher_key", trigger: "blur" },
        ],
        activation_date: [
          { required: true, message: "请选择开通日期", trigger: "change" },
        ],
        base_url: [
          { required: true, message: "请输入 base_url", trigger: "blur" },
        ],
        default_currency: [
          { required: true, message: "请输入默认币种", trigger: "blur" },
        ],
        default_time_zone: [
          { required: true, message: "请输入默认时区", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择状态", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    async submitForm(formParams) {
      const data = await this.$api.getConfig.postAddConfig(formParams);
      if (data.code == 200) {
        this.getList();
        this.$message.success("操作成功");
      }
    },
    async getList() {
      const data = await this.$api.getConfig.getConfigList();
      this.list = (data.data || []).map((item) => {
        if (item.label) {
          item.label = item.label.split("@");
        }
        return item;
      });
    },
    async saveConfig(item) {
      const data = await this.$api.getConfig.postSaveConfig({
        iden: item.iden,
        value: item.value,
      });
      if (data.code == 200) {
        this.getList();
        this.$message.success("修改成功");
      }
    },
    toAdd() {
      this.$refs.appConfigDialogRef.openDialog("新增配置");
    },
    handleTabClick(tab) {
      if (tab.name === "report" && !this.accountLoaded) {
        this.loadReportAccount();
      }
    },
    resetReportAccountForm() {
      this.reportAccountForm = createDefaultReportAccountForm();
      this.showPublisherKey = false;
      if (this.$refs.reportAccountFormRef) {
        this.$refs.reportAccountFormRef.clearValidate();
      }
    },
    applyReportAccount(data) {
      const nextForm = createDefaultReportAccountForm();
      if (data) {
        nextForm.publisher_key = data.publisher_key || "";
        nextForm.activation_date = normalizeActivationDate(data.activation_date);
        nextForm.account_code = data.account_code || "global";
        nextForm.base_url = data.base_url || nextForm.base_url;
        nextForm.default_currency = data.default_currency || nextForm.default_currency;
        nextForm.default_time_zone = data.default_time_zone || nextForm.default_time_zone;
        nextForm.status = data.status || nextForm.status;
      }
      this.reportAccountForm = nextForm;
      this.showPublisherKey = false;
      if (this.$refs.reportAccountFormRef) {
        this.$refs.reportAccountFormRef.clearValidate();
      }
    },
    async loadReportAccount() {
      this.accountLoading = true;
      try {
        const data = await this.$api.getReport.getAccount({
          account_code: "global",
        });
        this.applyReportAccount(data);
        this.accountLoaded = true;
      } finally {
        this.accountLoading = false;
      }
    },
    async saveReportAccount() {
      const valid = await new Promise((resolve) => {
        this.$refs.reportAccountFormRef.validate((result) => resolve(result));
      });

      if (!valid) {
        return;
      }

      this.accountSaving = true;
      try {
        const payload = {
          publisher_key: this.reportAccountForm.publisher_key,
          activation_date: formatDateToYYYYMMDD(this.reportAccountForm.activation_date),
          account_code: "global",
          base_url: this.reportAccountForm.base_url,
          default_currency: this.reportAccountForm.default_currency,
          default_time_zone: this.reportAccountForm.default_time_zone,
          status: this.reportAccountForm.status,
        };
        const data = await this.$api.getReport.saveAccount(payload);
        this.applyReportAccount(data);
        this.accountLoaded = true;
        this.$message.success("报表账户配置保存成功");
      } finally {
        this.accountSaving = false;
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.config-page {
  width: 100%;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background-color: #f8f8f8;
  margin-top: 12px;
  padding: 16px 12px;
  border-radius: 8px;
  font-size: 12px;
}

.left {
  min-width: 240px;
}

.title {
  color: #203864;
  font-weight: 600;
}

.right {
  flex: 1;
}

.report-account-card {
  padding: 8px 4px 0;
}

.report-account-head {
  margin-bottom: 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  h3 {
    margin: 0;
    color: #203864;
    font-size: 20px;
  }

  p {
    margin: 8px 0 0;
    color: #7b93ba;
    font-size: 13px;
  }
}

.report-account-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.password-toggle {
  cursor: pointer;
  color: #6b84ad;
}

@media (max-width: 960px) {
  .row {
    flex-direction: column;
    align-items: stretch;
  }

  .left {
    min-width: 0;
  }

  .report-account-head {
    flex-direction: column;
  }

  /deep/ .el-col {
    width: 100%;
  }
}
</style>
